import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { ORIGINS } from "constants";

/**
 * useSignupForm
 *
 * @param {Function} onSignupCompleted
 */
export default function useSignupForm({ onSignupCompleted }) {
  const [searchParams] = useSearchParams();

  const [formData, setFormData] = useState(() => {
    let signupOriginType;
    let signupOriginId;

    const originKey = Object.keys(ORIGINS).find((key) => {
      const value = searchParams.get(key);

      if (value) {
        signupOriginType = ORIGINS[key];
        signupOriginId = value;
        return true;
      }

      return false;
    });

    return {
      partner: searchParams.get("partner"),
      channel: searchParams.get("channel"),
      source: searchParams.get("source"),
      ...(originKey && { signupOriginType, signupOriginId }),
    };
  });

  const [signupCompleted, setSignupCompleted] = useState(false);

  const handleFormChange = useCallback((payload) => {
    setFormData((current) => ({
      ...current,
      ...payload,
    }));
  }, []);

  useEffect(() => {
    onSignupCompleted?.(signupCompleted);
  }, [signupCompleted, onSignupCompleted]);

  return {
    formData,
    handleFormChange,
    signupCompleted,
    setSignupCompleted,
  };
}
